export default __webpack_public_path__ + "static/media/sass.036ebb1c.svg";